import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

import ContactForm from '../../components/ContactForm';

import { Container, Undraw } from './styles';

import undrawImage from '../../assets/undraw02.svg';

export default function Contact() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Container id='contact' data-aos='fade-right'>
        <Undraw src={undrawImage} alt='Undraw' />
        <ContactForm />
      </Container>
    </>
  );
}
